import React from "react"
import { Box, Button, Typography } from "@strapi/design-system"

interface AddProductsModalProps {
  title: string
  description: string
  onClick: () => void
}
export const AddProductCard: React.FC<AddProductsModalProps> = ({
  title,
  description,
  onClick,
}) => {
  return (
    <Box
      hasRadius
      style={{
        display: "flex",
        flexDirection: "column",
        width: "180px",
        alignItems: "center",
        cursor: "pointer",
        margin: "20px",
      }}
    >
      <Button style={{ height: "37px", textAlign: "center" }} fullWidth={true} onClick={onClick}>
        {title}
      </Button>

      <Box style={{ width: "180px", marginTop: "20px", textAlign: "center" }}>
        <Typography variant="EPSILON" style={{ color: "#666684" }}>
          {description}
        </Typography>
      </Box>
    </Box>
  )
}
